module.exports = __webpack_public_path__ + "img/prostye-zvonki.57a3f4dd.png";